import { HttpClient, HttpContext, HttpRequest } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';

import { BehaviorSubject, delay, retry, scan, takeUntil, tap } from 'rxjs';
import { OVERRIDE_CTX } from 'src/app/core/interceptors/http-error.interceptor';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';

import { LoadSpinnerService } from '../spinner/loadspinner.service';

@Injectable({ providedIn: 'root' })
export class ApiloaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  //WITH DEBOUNCE TO DELAY SHOW
  // loading$ = this.loadingSubject.asObservable().pipe(
  //   debounceTime(200),
  //   distinctUntilChanged()
  // );

  public readonly loading$ = this.loadingSubject.asObservable(); //No delayed show

  private requestsDur: number[] = [];
  private requests: { url: string, method: string, dur: number }[] = [];
  isOffline = new BehaviorSubject<boolean>(false);
  public readonly isOffline$ = this.isOffline.asObservable();
  isAPIOffline = new BehaviorSubject<boolean>(false);
  public readonly isAPIOffline$ = this.isAPIOffline?.asObservable();

  isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading?.asObservable();

  constructor(public loaderService: LoadSpinnerService, private http: HttpClient, private toastService: ToastService) {
    this.updateOnlineStatus();
    window.addEventListener('online', this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));
  }


  getServerAvailable() {
    return this.http.get(environment.apiUrl + '/loan/api/admin/is-available', {
      context: new HttpContext().set(OVERRIDE_CTX, true),
    });
  }

  private updateOnlineStatus(): void {
    this.isOffline.next(!window.navigator.onLine);
    console.info(`isOnline=[${window.navigator.onLine}]`);
  }

  public setAPIStatus(currentstatus: boolean): void {
    this.isAPIOffline.next(!currentstatus);
    console.info(`APIStatus=[${currentstatus}]`);
  }

  WaitforOnline(lastreq?: HttpRequest<any>): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const loadingService = this.loaderService;
      loadingService.startLoading('Attempting reconnect, please wait!');

      this.getServerAvailable().pipe(
        tap(() => {
          this.isAPIOffline.next(false);
          this.isOffline.next(false);
        }),
        retry({
          delay: (errors) =>
            errors.pipe(
              takeUntil(this.isOffline), // will stop retries if offline state is emitted
              tap(() => console.warn('Retrying server request...')),
              delay(10000),
              scan((retryCount, err) => {
                if (retryCount >= 5) {
                  throw new Error('Max retries reached');
                }
                return retryCount + 1;
              }, 0)
            )
        }),
        takeUntil(this.isOffline)
      ).subscribe({
        next: (serverres:any) => {
          if ((serverres?.status as string)?.startsWith('OK')) {
            this.removeRequest(lastreq!);
            // Loader and offline image already updated via `tap`
            resolve(true);
          }
        },
        error: (err) => {
          this.isAPIOffline.next(true); // signal to show offline image
          this.isOffline.next(true); // halt other streams with takeUntil
          reject(new Error('Failed to reconnect to the server'));
        },
        complete: () => loadingService.stopLoading()
      });
    });
  }

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }

  setRequest = (req: HttpRequest<any>) => {
    this.requests.push({ url: req.url, method: req.method, dur: performance.now() });
    this.requestsDur.push(performance.now());
    if (isDevMode()) {
      console.info('LoaderService[DevModeOnly]: ', req.url);
    }
    return req;
  };

  removeRequest = (req: HttpRequest<any>) => {
    //this.requests = this.requests.filter(r => r.url !== req.url && r.method !== req.method);
    const ireq = this.requests.findIndex((r) => r.url === req.url && r.method === req.method);
    if(ireq >= 0) {
      this.logRequestTime(this.requests[ireq].dur, req.url, req.method);
      this.requests.splice(ireq, 1);
    }
  };

  private logRequestTime(startTime: number, url: string, method: string) {
    const requestDuration = `${performance.now() - startTime}`;
    console.info(`[${method}] ${url}: ${requestDuration} msecs`);
  }
}
